export const JOIN_SKELETON = 'join-skeleton';
export const JOIN_LABEL = 'join-label';
export const JOIN_MENU_ROOT = 'join-menu-root';
export const JOIN_MENU_TILE_LINK = 'join-menu-tile-link';
export const JOIN_MENU_TILE_DESCRIPTION = 'join-menu-tile-description';
export const JOIN_MENU_BACKDROP = 'join-menu-backdrop';
